import React, {lazy, Suspense} from "react";
const FaEnvelope = lazy(() => import("react-icons/fa").then(module => ({ default: module.FaEnvelope })));
const FaMobileAlt = lazy(() => import("react-icons/fa").then(module => ({ default: module.FaMobileAlt })));
const FaLocationArrow = lazy(() => import("react-icons/fa6").then(module => ({ default: module.FaLocationArrow })));

const FooterSkeleton = () => {
    const IconWrapper = ({ Icon, className = "", size = 20, ...props }) => (
        <Suspense
            fallback={
                <div
                    className={`inline-block min-w-[${size}px] min-h-[${size}px] w-[${size}px] h-[${size}px]`}
                />
            }
        >
            <Icon
                {...props}
                className={`${className} inline-block min-w-[${size}px] min-h-[${size}px] w-[${size}px] h-[${size}px]`}
                size={size}
            />
        </Suspense>
    );

    const ContactItem = ({ href, Icon, text }) => (
        <div className="min-h-[24px] flex items-center gap-3">
            {text ? (
                <a href={href} target="_blank" rel="noopener noreferrer">
                    <div className="flex items-center gap-3">
                        <IconWrapper Icon={Icon} className="text-gray hover:text-primary" size={20} />
                        <p className="text-gray font-semibold hover:text-primary">{text}</p>
                    </div>
                </a>
            ) : (
                <div className="w-24 h-3 bg-gray-200 rounded animate-pulse"></div>
            )}
        </div>
    );
    return (
            <div className="grid md:grid-cols-3">
                <div className="py-8 px-4 flex flex-col items-start gap-3">
                    <div className="w-24 h-[72px] overflow-hidden shrink-0 relative">
                        <img
                            src="https://stemcity.s3.ap-southeast-2.amazonaws.com/logo/stemcity.webp?v=1615"
                            width="96"
                            height="72"
                            alt="Stemcity footer logo - STEM Learning"
                            title="Stemcity footer logo - STEM Learning"
                            className="w-full h-full object-contain"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                    <p className="text-black dark:text-gray min-h-[60px] text-base leading-relaxed">
                        STEMCITY® empowers young minds with DIY STEM, Robotics & AI kits—making learning fun, hands-on, and innovative for schools, homes, and future creators. Learn by doing, build your future!
                    </p>
                </div>

                <div className="col-span-2 grid grid-cols-2 sm:grid-cols-3 md:pl-10">
                    <div className="py-8 px-4">
                        <h2 className="text-xl font-bold sm:text-left mb-3">Quick Links</h2>
                        <ul className="space-y-3">
                            {[
                                { name: "Home", href: "/" },
                                { name: "Shop", href: "/products" },
                                { name: "Grade", href: "/grades" },
                                { name: "Shop By Age", href: "/shop-by-age" },
                                { name: "Contact Us", href: "/contact" },
                            ].map((link, idx) => (
                                <li key={idx}>
                                    <a className="text-gray dark:text-gray font-semibold hover:text-primary duration-300" href={link.href}>
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="py-8 px-4">
                        <h2 className="text-xl font-bold sm:text-left mb-3">Important Links</h2>
                        <ul className="space-y-3">
                            {[
                                { name: "Terms & Conditions", href: "/terms-and-conditions" },
                                { name: "Privacy Policy", href: "/privacy-policy" },
                                { name: "Refund and Cancellation Policy", href: "/refund-and-cancellation" },
                                { name: "Return Policy", href: "/return-policy" },
                                { name: "Shipping Policy", href: "/shipping-policy" },
                            ].map((link, idx) => (
                                <li key={idx}>
                                    <a className="text-gray dark:text-gray font-semibold hover:text-primary duration-300" href={link.href}>
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="py-8 px-4 col-span-2 sm:col-auto">
                        <h2 className="text-xl font-bold sm:text-left mb-3">Contact</h2>
                        <div className="space-y-6">
                            <ContactItem
                                href="https://www.google.com/maps/place/Suncity+Avenue+76/@28.3924775,76.9918135,17z"
                                Icon={FaLocationArrow}
                                text="B8-505, Suncity Avenue 76, Sector 76, Gurugram, Haryana-122004"
                            />
                            <ContactItem
                                href="tel:9599185057"
                                Icon={FaMobileAlt}
                                text="9599185057"
                            />
                            <ContactItem
                                href="mailto:info@stemcity.in"
                                Icon={FaEnvelope}
                                text="info@stemcity.in"
                            />
                            <div className="min-h-[24px] flex items-center gap-3">
                                <div className="w-24 h-3 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
    );
};

export default React.memo(FooterSkeleton);
